import { Component, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { Datenabfrage } from '../../domain/model/datenabfrage/datenabfrage';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { DatenabfrageService } from '../../service/datenabfrage/datenabfrage.service';
import { take } from 'rxjs/operators';
import { NotificationService } from '../../service/common/notification/notification.service';
import { NgForm } from '@angular/forms';
import { ConfirmDialogService } from '../../service/common/confirm-dialog/confirm-dialog.service';
import { formatDate } from '@angular/common';

@Component({
    selector: 'tnb-datenabfrage-create',
    templateUrl: './datenabfrage-create.component.html',
    styleUrls: [
        './datenabfrage-create.component.scss',
    ],
    standalone: false,
})
export class DatenabfrageCreateComponent {
    private confirmDialogService = inject(ConfirmDialogService);
    private datenabfrageService = inject(DatenabfrageService);
    private notificationService = inject(NotificationService);
    private westnetzSidenavService = inject(WestnetzSidenavService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    @ViewChild('datenabfrageForm', { static: true }) public datenabfrageForm: NgForm;
    public datenabfrage = new Datenabfrage();

    public tomorrow = new Date().setDate(new Date().getDate() + 1);

    public async createNewDatenabfrage() {

        const message = 'Es wird nun ein Abfrage namens \'' +
            this.datenabfrage.bezeichnung + '\' ' +
            'erstellt mit den folgenden Daten:<br/><br/>' +
            'Abgabefrist: ' + formatDate(this.datenabfrage.abgabefrist, 'dd.MM.yyyy', 'de-DE') + '<br/>' +
            'Referenzzeitraum Endverbraucherlast: ' +
            formatDate(this.datenabfrage.referenzzeitraumEndverbraucherlast, 'dd.MM.yyyy', 'de-DE') + '<br/>' +
            'Referenzzeitraum Erzeugungsleistung: ' +
            formatDate(this.datenabfrage.referenzzeitraumErzeugerleistung, 'dd.MM.yyyy', 'de-DE') + '<br/><br/>' +
            'Diese Daten können nachträglich nicht mehr verändert werden!';

        const result = await this.confirmDialogService.confirm(
            message,
            'Abfrage erstellen',
            'primary',
            'Erstellen',
            'Abbrechen',
            'save',
        );
        if (result) {
            this.datenabfrageService.createDatenabfrage(this.datenabfrage)
                .pipe(take(1))
                .subscribe(_da => {
                    this.westnetzSidenavService.closeRightnav();
                    this.notificationService.success('Die Datenabfrage wurden erstellt');
                });
        }
    }

    public isSaveButtonDisabled(): boolean {
        return !this.datenabfrageForm || !this.datenabfrageForm.form.valid || this.datenabfrageForm.form.pristine;
    }

    public cancel() {
        this.westnetzSidenavService.closeRightnav();
    }
}
